import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Form, TextArea, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class Rejecter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'isOpen': false,
      'description': '',
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }

  handleOpen() {
    this.setState({'isOpen': true});
  }

  handleClose() {
    this.setState({'isOpen': false, 'description': ''});
  }

  handleDescriptionChange(event, data) {
    this.setState({'description': data.value.toUpperCase()});
  }

  handleReject() {
    const {orders} = this.props;
    const workElement = orders[0];
    this.props.rejectProviderOrderAuthorization({
      'orderCode': workElement.orderCode,
      'emailUserRequest': workElement.emailUserRequest,
      'comment': this.state.description,
    });
    this.handleClose();
  }

  getButtonStatus() {
    const {description} = this.state;
    return !description || description.length < 5;
  }

  render() {
    const {isOpen, description} = this.state;
    return (
      <Modal
        size='small'
        open={isOpen}
        trigger={<Button secondary content='RECHAZAR' onClick={this.handleOpen} />}
      >
        <Modal.Content>
          <div className='order-authorization'>
            <h4>Ingrese el motivo del rechazo</h4>
            <Form>
              <TextArea rows={2} value={description} onChange={this.handleDescriptionChange}/>
            </Form>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button secondary content='CANCELAR' onClick={this.handleClose} />
          <Button primary
            content='CONFIRMAR'
            disabled={this.getButtonStatus()}
            onClick={this.handleReject}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const {
  rejectProviderOrderAuthorization,
} = Actions;

export default connect(null, {
  rejectProviderOrderAuthorization,
})(Rejecter);
